import { render, staticRenderFns } from "./secondarydealerfiles.vue?vue&type=template&id=d630378c&scoped=true&"
import script from "./secondarydealerfiles.vue?vue&type=script&lang=js&"
export * from "./secondarydealerfiles.vue?vue&type=script&lang=js&"
import style0 from "./secondarydealerfiles.vue?vue&type=style&index=0&id=d630378c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d630378c",
  null
  
)

export default component.exports